import { render, staticRenderFns } from "./details-matrix.page.vue?vue&type=template&id=6c8544ca&scoped=true"
import script from "./details-matrix.page.vue?vue&type=script&lang=js"
export * from "./details-matrix.page.vue?vue&type=script&lang=js"
import style0 from "./details-matrix.page.vue?vue&type=style&index=0&id=6c8544ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8544ca",
  null
  
)

export default component.exports